export default {"src":"/_next/static/media/highlightminswatched.65dc6c8c.svg","height":180,"width":284};